import { render } from "./Bloodevent.vue?vue&type=template&id=60e75612&scoped=true"
import script from "./Bloodevent.vue?vue&type=script&lang=js"
export * from "./Bloodevent.vue?vue&type=script&lang=js"

import "./Bloodevent.vue?vue&type=style&index=0&id=60e75612&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e75612"]])

export default __exports__